import { all, fork } from 'redux-saga/effects'

// core
import core from '@redux/saga/core'
import admin from '@redux/saga/admin'
import main from '@redux/saga/main'
import home from '@redux/saga/home'
// @PLOP-IMPORTS

export default function* rootSaga() {
	yield all([
		fork(core),
		fork(admin),
		fork(main),
		fork(home),
		// @PLOP-CODE
	])
}
